import { render } from "./Forum.vue?vue&type=template&id=082f4df7&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"

import "./Forum.vue?vue&type=style&index=0&id=082f4df7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-082f4df7"

export default script